module.exports = __webpack_public_path__ + "static/img/bg3.7cbcbf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg3.png
// module id = 558
// module chunks = 1